<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet />

      <ion-tab-bar slot="bottom" class="tab-bar" color="light">
        <ion-tab-button
          v-for="tab in tabs"
          :key="tab.id"
          :tab="tab.id"
          :href="tab.href"
          @click="changeTab($event, tab)"
        >
          <ion-icon :icon="tab.icon" />
          <ion-label>{{ tab.label }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import {
  IonPage,
  IonRouterOutlet,
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel,
  useIonRouter,
} from "@ionic/vue";
import { Tab } from "@/common/components/types";
import { useUserStore } from "@/common/store/user.store";

export default defineComponent({
  components: {
    IonPage,
    IonRouterOutlet,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
  },

  props: {
    tabs: {
      type: Array as PropType<Tab[]>,
      required: true,
      validator: (tabs: Tab[]) => tabs.length > 0,
    },
  },

  setup() {
    const ionRouter = useIonRouter();
    const changeTab = (event: any, tab: Tab) => {
      event.preventDefault();
      ionRouter.navigate(tab.href, "forward", "push");
      useUserStore().fetchCurrentUser();
    };
    return {
      changeTab,
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-bar > ion-tab-button {
  --ion-color-contrast: var(--ion-color-primary);
}
</style>
